'use client'

import Checkbox from '@/app/_components/Search/SearchResult/Checkbox'
import { Options } from '@/app/_components/Shared/Dropdown'
import { DropdownMenu } from '@/app/_components/Shared/DropdownMenu'
import { useSearchParams } from '@/libraries/search-params'
import { useSearchParams as next_useSearchParams } from 'next/navigation'
import { z } from 'zod'

const sortArr = [
  {
    id: 'latest',
    content: <>업데이트순</>,
  },
  {
    id: 'hot',
    content: <>인기순</>,
  },
]

const dateSortArr = [
  // {
  //   id: 'current',
  //   content: <>실시간 인기</>,
  // },
  {
    id: 'week',
    content: <>주간 인기</>,
  },
  {
    id: 'month',
    content: <>월간 인기</>,
  },
  {
    id: 'year',
    content: <>연간 인기</>,
  },
]

export function SortContent() {
  const searchParams = next_useSearchParams()
  const params = new URLSearchParams(searchParams)
  const [state, setState] = useSearchParams(
    z.object({
      sorting: z.string().default('latest'),
      sortForDate: z.string().default('week').optional(),
      isVerified: z.string().default('n'),
    }),
  )
  const currentSort = sortArr.filter(
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (s) => s.id === state.sorting,
  )[0]

  const currentSortForDate = dateSortArr.filter(
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (s) => s.id === state.sortForDate,
  )[0]

  return (
    <div className="fullpage-container mb-20 flex w-full flex-wrap items-center gap-16 max-xl:mt-20 lg:gap-32">
      <DropdownMenu
        className="c-b4 h-48 w-full border-1 border-tertiary"
        containerClassName="max-w-140 h-48 "
        options={sortArr}
        selected={currentSort ?? sortArr[0]}
        onSelect={(option: Options) => {
          if (option.id === 'latest') {
            params.delete('sortForDate')
            setState({
              sorting: option.id,
              isVerified: state.isVerified,
            })
            return
          }

          setState({
            ...state,
            sorting: option?.id ?? state.sorting,
            sortForDate: 'week',
          })
        }}>
        정렬
      </DropdownMenu>

      {state.sorting === 'hot' && (
        <DropdownMenu
          className="c-b4 h-48 w-full border-1 border-tertiary"
          containerClassName="lg:max-w-340 h-48 "
          options={dateSortArr}
          selected={currentSortForDate ?? dateSortArr[0]}
          onSelect={(option: Options) => {
            setState({
              ...state,
              sortForDate: option.id,
            })
          }}>
          날짜별 정렬
        </DropdownMenu>
      )}

      <Checkbox
        checked={Boolean(state.isVerified === 'y')}
        onChecked={() => {
          setState({
            ...state,
            isVerified: state.isVerified === 'y' ? 'n' : 'y',
          })
        }}
        key={'isVerified'}
        className="max-xl:hidden">
        <p className=" c-b4 text-left text-[#4B5157]">인증된 IP만 보기</p>
      </Checkbox>
    </div>
  )
}
